// extracted by mini-css-extract-plugin
module.exports = {"userInfo":"style-module--userInfo--2gbmx","userInfoItem":"style-module--userInfoItem--2Gvom","avatar":"style-module--avatar--pWQnT"};